export default __webpack_public_path__ + "static/media/empty-programmes-switch.b2ef1587.svg";